import React, { useState } from "react";
import clsx from "clsx";
import { useDispatch } from "react-redux";

import { TableRow, TableCell, Box } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import CustomDialog from "../AccessList/CustomDialog";
import EventsRequests from "services/events";
import AddEventTokenDialog from "./AddEventTokenDialog";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    width: "20%",
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const ListTableItem = ({ item }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const classes = useStyles();
  const dispatch = useDispatch();
  const handleDeleteUserUserAccess = () => {
    setOpenRemoveDialog(false);
    dispatch(EventsRequests.removeEventTokenTicket(item._id));
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {item.name}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {item.description}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {item.token}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
        >
          <Box display={"flex"}>
            <Box
              className={classes.createIconContainer}
              onClick={() => setOpenRemoveDialog(true)}
            >
              <Delete />
            </Box>
            <Box
              className={classes.createIconContainer}
              onClick={() => setOpenEditDialog(true)}
            >
              <EditIcon />
            </Box>
          </Box>
        </TableCell>
      </TableRow>

      <AddEventTokenDialog
        open={openEditDialog}
        handleClose={() => setOpenEditDialog(false)}
        item={item}
      />

      <CustomDialog
        text={"آیا از حذف این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDeleteUserUserAccess}
      />
    </React.Fragment>
  );
};

export default ListTableItem;
